import React, { useState, Suspense, useRef, useLayoutEffect, createRef } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import PageLoader from '../common/PageLoader';
import { 
  COOKIE_DOMAIN, 
  DASHBOARD_LINK, 
  COVERLETTER_JOBDETAILS
} from '../../constants/constants';
import { createCoverLetterTemplate, initiateCoverLetterQA, updateCoverLetterTemplate } from '../../services/actions/actions';
import LazyLoad from 'react-lazy-load';
let TPL = {}
// TPL['template-one'] = React.lazy(() => import('./templates/static/TemplateOne'));
// TPL['template-one-v2'] = React.lazy(() => import('./templates/static/TemplateOneV2'));
// TPL['template-one-v3'] = React.lazy(() => import('./templates/static/TemplateOneV3'));
// TPL['template-two'] = React.lazy(() => import('./templates/static/TemplateTwo'));
// TPL['template-two-v2'] = React.lazy(() => import('./templates/static/TemplateTwoV2'));
// TPL['template-two-v3'] = React.lazy(() => import('./templates/static/TemplateTwoV3'));
// TPL['template-three'] = React.lazy(() => import('./templates/static/TemplateThree'));
// TPL['template-three-v2'] = React.lazy(() => import('./templates/static/TemplateThreeV2'));
// TPL['template-three-v3'] = React.lazy(() => import('./templates/static/TemplateThreeV3'));
// TPL['template-three-v4'] = React.lazy(() => import('./templates/static/TemplateThreeV4'));
// TPL['template-three-v5'] = React.lazy(() => import('./templates/static/TemplateThreeV5'));
// TPL['template-four'] = React.lazy(() => import('./templates/static/TemplateFour'));
// TPL['template-four-v2'] = React.lazy(() => import('./templates/static/TemplateFourV2'));
// TPL['template-four-v3'] = React.lazy(() => import('./templates/static/TemplateFourV3'));
// TPL['template-four-v4'] = React.lazy(() => import('./templates/static/TemplateFourV4'));
// TPL['template-four-v5'] = React.lazy(() => import('./templates/static/TemplateFourV5'));
// TPL['template-five'] = React.lazy(() => import('./templates/static/TemplateFive'));
// TPL['template-five-v2'] = React.lazy(() => import('./templates/static/TemplateFiveV2'));
// TPL['template-five-v3'] = React.lazy(() => import('./templates/static/TemplateFiveV3'));
// TPL['template-five-v4'] = React.lazy(() => import('./templates/static/TemplateFiveV4'));
// TPL['template-five-v5'] = React.lazy(() => import('./templates/static/TemplateFiveV5'));
// TPL['template-six'] = React.lazy(() => import('./templates/static/TemplateSix'));
// TPL['template-six-v2'] = React.lazy(() => import('./templates/static/TemplateSixV2'));
// TPL['template-six-v3'] = React.lazy(() => import('./templates/static/TemplateSixV3'));
// TPL['template-seven'] = React.lazy(() => import('./templates/static/TemplateSeven'));
// TPL['template-seven-v2'] = React.lazy(() => import('./templates/static/TemplateSevenV2'));
// TPL['template-seven-v3'] = React.lazy(() => import('./templates/static/TemplateSevenV3'));
// TPL['template-eight'] = React.lazy(() => import('./templates/static/TemplateEight'));
// TPL['template-eight-v2'] = React.lazy(() => import('./templates/static/TemplateEightV2'));
// TPL['template-eight-v3'] = React.lazy(() => import('./templates/static/TemplateEightV3'));
// TPL['template-nine'] = React.lazy(() => import('./templates/static/TemplateNine'));
// TPL['template-nine-v2'] = React.lazy(() => import('./templates/static/TemplateNineV2'));
// TPL['template-nine-v3'] = React.lazy(() => import('./templates/static/TemplateNineV3'));
//TPL['template-ten'] = React.lazy(() => import('./templates/static/TemplateTen'));
// TPL['template-ten-v2'] = React.lazy(() => import('./templates/static/TemplateTenV2'));
// TPL['template-ten-v3'] = React.lazy(() => import('./templates/static/TemplateTenV3'));
// TPL['template-ten-v4'] = React.lazy(() => import('./templates/static/TemplateTenV4'));
// TPL['template-ten-v5'] = React.lazy(() => import('./templates/static/TemplateTenV5'));
TPL['template-eleven'] = React.lazy(() => import('./templates/static/TemplateEleven'));
TPL['template-twelve'] = React.lazy(() => import('./templates/static/TemplateTwelve'));
TPL['template-thirteen'] = React.lazy(() => import('./templates/static/TemplateThirteen'));
TPL['template-fourteen'] = React.lazy(() => import('./templates/static/TemplateFourteen'));
//TPL['template-fifteen'] = React.lazy(() => import('./templates/static/TemplateFifteen'));
TPL['template-sixteen'] = React.lazy(() => import('./templates/static/TemplateSixteen'));
TPL['template-sixteen-v2'] = React.lazy(() => import('./templates/static/TemplateSixteenV2'));
TPL['template-seventeen'] = React.lazy(() => import('./templates/static/TemplateSeventeen'));
TPL['template-eighteen'] = React.lazy(() => import('./templates/static/TemplateEighteen'));
TPL['template-nineteen'] = React.lazy(() => import('./templates/static/TemplateNineteen'));
TPL['template-twenty'] = React.lazy(() => import('./templates/static/TemplateTwenty'));
TPL['template-twenty-one'] = React.lazy(() => import('./templates/static/TemplateTwentyOne'));
TPL['template-twenty-three'] = React.lazy(() => import('./templates/static/TemplateTwentyThree'));
TPL['template-twenty-three-v2'] = React.lazy(() => import('./templates/static/TemplateTwentyThreeV2'));
TPL['template-twenty-four'] = React.lazy(() => import('./templates/static/TemplateTwentyFour'));
const ListTemplate = (props) => {
  const rows = props.hasOwnProperty('rows') ? props.rows : 1;
  const templates = props.templates;
  const color = props.color;
  const customColor = props.customColor;
  const headerColor = props.headerColor;
  const page = props.page;
  
  const [redirect, setRedirect] = useState(false);
  const [singleItemHeight, setSingleItemHeight] = useState(window.innerWidth <= 768 || window.orientation === 90 || window.orientation === -90 ? 135 : 267);
  const [singleItemWidth, setSingleItemWidth] = useState(window.innerWidth <= 768 ? 100 : "auto");
  const dispatch = useDispatch();
  const refs = useRef(templates.map(createRef));
  const selectedTmp = (id) => ( (props?.active_template == id) || ( id == props?.selectedTpl) )
  useLayoutEffect(() => {
    setTimeout(() => {
      if(refs.current[0].current != null){
        setSingleItemWidth(refs.current[0].current.offsetWidth);
        let sih = (refs.current[0].current.offsetHeight > singleItemHeight ? refs.current[0].current.offsetHeight : singleItemHeight);
        sih = (refs.current[0].current.offsetTop > sih ? refs.current[0].current.offsetTop : sih);
        setSingleItemHeight(sih);
      }
    }, 300);
  }, [refs]);
  const templateGroups = rows > 1 ? templates.map((e, i) => {
    return i % rows === 0 ? templates.slice(i, i + rows) : null;
  }).filter(e => { return e; }) : [];
  // if (redirect && page == 'choose-template'){
  //   history.pushState(null, DASHBOARD_LINK); 
  //   return <Redirect to={COVERLETTER_JOBDETAILS} /> 
  // }
  
  
  return (
    <div className="template-items" id="template-item-id">
      {templates.length ? templates.map((template, index) => {
        const TplName = TPL[template.id];
        return (
          <div className={`template-single-item${selectedTmp(template.id) ? ' border' : ''}`} key={template.id}>
            <LazyLoad   threshold={0.15} onContentVisible={() => {console.log('loaded!')}} key={index}>
            <div
              role="button"
              ref={refs.current[index]} 
              className={`template-item ` + color}
              onClick={() => {
                
                if(props.page == 'choose-template' ){
                  // localStorage.setItem('cl_color', color ? color : template.color)
                  props?.setSelectedTpl(template.id)
                  props?.setSelectedColor(template.color)
                  // localStorage.setItem('cl_tpl', template.id)
                  // localStorage.setItem('cl_color', template.color);
                  // Cookies.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" });
                  // dispatch(initiateCoverLetterQA(customColor ? customColor : '', color ? color : template.color, template.id, params.exp))
                }else{
                  dispatch(updateCoverLetterTemplate(customColor ? customColor : '', color ? color : template.color, template.id))
                }
                let ua_cat = (
                  props.hasOwnProperty('pagepage') && props.page == 'quick-editor' 
                  ? 'Quick Editor' 
                  : 'Choose Template'
                );
                gaTrack('RT App', ua_cat, `Template ${template.id}`);
                let ga_cat = (
                  props.hasOwnProperty('page') && props.page == 'quick-editor' 
                  ? 'app_quick_editor_template_' 
                  : 'app_choose_template_cl_'
                ) + template.id;
                ga4Track(ga_cat, 'RT App', `Template ${template.id}`);
                // setRedirect(true);
              }}
            >
              <Suspense fallback={<PageLoader />}>
                {Object.keys(TPL).includes(template.id) ? (
                  <div className="static-view" >
                    <TplName color={color ? color : template.color} customColor={customColor} headerColor={headerColor} />
                  </div>)
                  : (
                  ""
                )}
              </Suspense>
            </div>
              
            </LazyLoad>

           </div>
        );
      }) : <PageLoader />}
    </div>
  )
}
export default ListTemplate;
